var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { InputAdornment } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import TextField from '../TextField/TextField';
export var UOM;
(function (UOM) {
    UOM["miles"] = "Miles";
    UOM["km"] = "KM";
})(UOM || (UOM = {}));
var roundUOM = function (v, decimals) {
    var mult = Math.pow(10, decimals);
    return Math.round(v * mult) / mult;
};
var MILES_PER_METER = 0.000621371;
var convertMetersToMiles = function (meters, decimals) {
    return roundUOM(meters * MILES_PER_METER, decimals);
};
var convertMilesToMeters = function (miles, decimals) {
    return roundUOM(miles / MILES_PER_METER, decimals);
};
var METERS_PER_KM = 1000;
var convertMetersToKM = function (meters, decimals) {
    return roundUOM(meters / METERS_PER_KM, decimals);
};
var convertKMToMeters = function (km, decimals) {
    return roundUOM(km * METERS_PER_KM, decimals);
};
var convertToUOM = function (v, decimals, uom) {
    if (!v)
        return '';
    var value = parseFloat(v);
    if (uom === UOM.miles) {
        return convertMetersToMiles(value, decimals);
    }
    return convertMetersToKM(value, decimals);
};
var convertFromUOM = function (v, decimals, uom) {
    if (!v)
        return '';
    var value = parseFloat(v);
    if (uom === UOM.miles) {
        return convertMilesToMeters(value, decimals);
    }
    return convertKMToMeters(value, decimals);
};
export default function TextFieldUOM(props) {
    var label = props.label, propValue = props.value, variant = props.variant, readOnly = props.readOnly, style = props.style, onChange = props.onChange, _a = props.decimals, decimals = _a === void 0 ? 2 : _a, error = props.error, min = props.min, max = props.max, step = props.step, uom = props.uom, helperText = props.helperText, InputProps = props.InputProps, inputProps = props.inputProps, otherProps = __rest(props, ["label", "value", "variant", "readOnly", "style", "onChange", "decimals", "error", "min", "max", "step", "uom", "helperText", "InputProps", "inputProps"]);
    var t = useTranslation().t;
    var value = convertToUOM(propValue || '', decimals, uom).toString();
    return (React.createElement(TextField, __assign({ label: label, variant: variant, style: style, error: error, onChange: function (e) {
            if (!onChange)
                return;
            var newValue = convertFromUOM(e.target.value, decimals, uom).toString();
            onChange(newValue);
        }, value: value, InputProps: __assign(__assign({}, InputProps), { type: 'number', endAdornment: React.createElement(InputAdornment, { position: "end" }, t(uom)), readOnly: readOnly }), 
        // the use of the two "inputProps" props is intended -- allow duplicates
        // eslint-disable-next-line
        inputProps: __assign(__assign({}, inputProps), { min: min, max: max, step: step }), helperText: helperText }, otherProps)));
}
//# sourceMappingURL=TextFieldUOM.js.map